export type FeaturePackagesMapping = {
  featureLabel: string;
  mappings: {
    [p in OfficePlans]: boolean;
  };
};

export enum OfficePlans {
  STANDARD_PLAN = 'MS_365_BUSINESS_STANDARD_PLAN',
  APPS_PLAN = 'MS_365_APPS_BUSINESS_PLAN',
  BASIC_PLAN = 'MS_365_BUSINESS_BASIC_PLAN'
}

export const PACKAGE_CODES = [OfficePlans.STANDARD_PLAN, OfficePlans.APPS_PLAN, OfficePlans.BASIC_PLAN];

export const FEATURE_PACKAGES_MAPPING: FeaturePackagesMapping[] = [
  {
    featureLabel: 'microsoft-365.compare-packages.feature.word-excel-pp',
    mappings: { [OfficePlans.STANDARD_PLAN]: true, [OfficePlans.APPS_PLAN]: true, [OfficePlans.BASIC_PLAN]: true }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.one-drive',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: true,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.email',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.app-desktop-versions',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: true,
      [OfficePlans.BASIC_PLAN]: false
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.teams',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.multi-user',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: true,
      [OfficePlans.BASIC_PLAN]: false
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.share-point',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.working-teams',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.bookings',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: false
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.yammer',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  },
  {
    featureLabel: 'microsoft-365.compare-packages.feature.planner',
    mappings: {
      [OfficePlans.STANDARD_PLAN]: true,
      [OfficePlans.APPS_PLAN]: false,
      [OfficePlans.BASIC_PLAN]: true
    }
  }
];
